









































































import { Component, namespace, mixins } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { NEWS_API } from '~/assets/config/api-path'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { filterDate } from '~/assets/filters/date'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import { IContent } from '~/assets/interfaces/content'
import { filterUrl } from '~/assets/filters/url'
import ComponentImage from '~/components/images/image.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentProductAdditionalWrapper from '~/components/products/product-additional-wrapper.vue'

const pageStore = namespace('page')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    LazyHydrate,
    ComponentNavigationBreadcrumbs,
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentProductAdditionalWrapper,
    ComponentImage,
  },
  filters: {
    filterDate,
    filterUrl,
  },
})
export default class pageContactsIndex extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        NEWS_API + '/' + route.params._id + '/'
      )

      return response
    } catch (err) {
      error({ statusCode: 404, message: 'Post not found' })
    }
  }

  private dateModified: string = ''
  private datePublished: string = ''
  private image: string[] = []
  private date: string = ''

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private productsAdditionalId: number | null = null
  private content: IContent[] = []
  private viewDetailPicture: string = ''
  private detailPicture: string = ''

  private created() {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  private get structuredData() {
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      dateModified: new Date(this.dateModified).toISOString(),
      datePublished: new Date(this.datePublished).toISOString(),
      headline: this.meta ? this.meta.h1 : '',
      image: this.image,
    }
  }

  private head() {
    return {
      script: [
        {
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }

  private get classContentImage() {
    return {
      [this.$style.contentImage]: true,
      [this.$style.left]: this.viewDetailPicture === 'left',
      [this.$style.right]: this.viewDetailPicture === 'right',
      [this.$style.width]:
        !this.viewDetailPicture || this.viewDetailPicture === 'width',
      [this.$style.desktop]: this.$device.isDesktop,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }
}
